// import logo from './logo.svg';
import { Route, Routes } from "react-router-dom";
import "./App.css";
import React, { useState, Suspense, lazy, useEffect } from "react";
import LoadingScreen from "./components/LoadingSection";
// import HeroSection from "./components/HeroSection";
// import Navbar from "./components/Navbar";
// import Providing from "./components/Providing";
// import Testimon from "./components/Testimon";
//import Home from "./components/Home";
// import Footer from "./components/Footer";
// import NotFound from "./components/pages/NotFound";
// import PrivacyPolicy from "./components/pages/PrivacyPolicy";
// import Works from "./components/Works";
// import Work from "./components/pages/Work";
// import HeroSection from "./components/HeroSection";
// import Testimon from "./components/Testimon";
// import FaqSection from "./components/FaqSection";
// import Providing from "./components/Providing";
// import LetsConnect from "./components/LetsConnect";
// import ContactForm from "./components/pages/ContactForm";
// import WorksGrid from "./components/WorksGrid";
import ScrollToTop from "./components/ScrollToTop";
// import WorksMini from "./components/WorksMini";
import AdminDashboard from "./components/superbase/AdminDashboard";
import AdminLogin from "./components/superbase/AdminLogin";
import PublicLayout from "./components/PublicLayout";
import AdminLayout from "./components/AdminLayout";
import Form from "./components/pages/Form";
// import bgConnect from "../images/contactbg.jpg";
import { ModalProvider } from "./components/modal/ModalContext";
import BookingForm from "./components/modal/BookingForm";
import GTMPageTracker from "./components/GTMPageTracker";
import HeroSection1 from "./components/darktheme/HeroSection1";
import Numbers1 from "./components/darktheme/Numbers1";
import Services1 from "./components/darktheme/Services1";
import Values1 from "./components/darktheme/Values1";
// import Testimonial1 from "./components/darktheme/Testimonial1";
// import Faq1 from "./components/darktheme/Faqs1";
// import Blogs1 from "./components/darktheme/Blogs1";
// import Contact1 from "./components/darktheme/Contact1";
import Statement1 from "./components/darktheme/Statement1";
import ServiceDetails from "./components/darktheme/pages/ServiceDetails";
import DigitalMarketing from "./components/pages/DigitalMarketing";
import WhatsAppButton from "./components/modal/WhatsAppButton";
import Thanks from "./components/pages/Thanks";
// import Portfolio from "./components/darktheme/Portfolio";

// import Services from "./components/pages/Services";
// import About from "./components/pages/About";
// import Blog from "./components/pages/Blog";
// import WorkPage from "./components/pages/WorkPage";
const Portfolio = lazy(() => import("./components/darktheme/Portfolio"));
const Testimonial1 = lazy(() => import("./components/darktheme/Testimonial1"));
const Faq1 = lazy(() => import("./components/darktheme/Faqs1"));
// const Blogs1 = lazy(() => import("./components/darktheme/Blogs1"));
const Contact1 = lazy(() => import("./components/darktheme/Contact1"));
// ✅ Lazy load non-critical (secondary) pages
const Services = lazy(() => import("./components/pages/Services"));
const WorkPage = lazy(() => import("./components/pages/WorkPage"));
const Blog = lazy(() => import("./components/pages/Blog"));
const About = lazy(() => import("./components/pages/About"));
const PrivacyPolicy = lazy(() => import("./components/pages/PrivacyPolicy"));
const NotFound = lazy(() => import("./components/pages/NotFound"));

function PrivateRoute({ children }) {
  const isLogged = localStorage.getItem("N_admin") === "true";
  return isLogged ? (
    children
  ) : (
    <AdminLogin onLogin={() => window.location.reload()} />
  );
}
function App() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem("first_visit_popup");

    if (!seen) {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 500); // 10 seconds changed to 5 milliseconds for testing

      // cleanup to avoid memory leaks
      return () => clearTimeout(timer);
    }
  }, []);

  const closePopup = () => {
    localStorage.setItem("first_visit_popup", "true");
    setShowPopup(false);
  };

  return (
    <>
      <ScrollToTop />
      {/* 🔥 GLOBAL FIRST-VISIT POPUP — PLACE IT HERE */}
      {showPopup && (
        <div
          className="
        fixed inset-0 z-[9999]
        flex items-center justify-center
        bg-black/30 backdrop-blur-md
      "
          onClick={closePopup}
        >
          <div
            className="
          relative w-full max-w-4xl mx-4
          rounded-xl bg-white p-6 shadow-2xl
        "
            // style={{
            //   backgroundImage: `url(${bgConnect})`,
            //   backgroundSize: "cover",
            //   backgroundPosition: "center",
            //   backgroundRepeat: "no-repeat",
            // }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closePopup}
              className="absolute right-4 top-4 text-gray-400 hover:text-gray-700"
            >
              ✕
            </button>

            {/* YOUR FORM */}
            <Form />
          </div>
        </div>
      )}
      <ModalProvider>
        <BookingForm />

        {/* <SmoothScrollProvider> */}
        <div
          className="App bg-black text-white"
          // old md:px-20
        >
          {/* <div className="flex justify-center items-center bg-white">
              <div className="relative w-[90%] max-w-sm">
                <svg
                  className="w-full h-auto"
                  viewBox="0 0 397 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M397 0H0C51.5649 1.28257 38.0479 35.0129 78.599 38H299.377C373.47 38 333.921 3.41573 397 0Z"
                    fill="#353535"
                  />
                </svg>

                <span className="absolute  inset-0 flex items-center justify-center text-white font-light text-base  md:text-[18px] gap-3 ">
                  <span className="animate-blink  w-3 h-3  rounded-full bg-green-500 inline-block"></span>
                  24/7 Available
                </span>
              </div>
            </div> */}

          {/* <Navbar /> */}
          {/* <HeroSection />
 


        {/* Suspense Wrapper for Lazy Loading */}
          <Suspense fallback={<LoadingScreen />}>
            <GTMPageTracker />
            <Routes>
              {/* ===================== PUBLIC ROUTES ===================== */}
              <Route element={<PublicLayout />}>
                <Route
                  path="/"
                  element={
                    <>
                      <HeroSection1 />
                      <Statement1 />
                      <Services1 />
                      <Numbers1 />
                      <Values1 />
                      <Suspense fallback={<div>Loading...</div>}>
                        <Portfolio />
                        <Testimonial1 />
                        {/* <Blogs1 /> */}
                        <Faq1 />
                        <Contact1 />
                      </Suspense>

                      {/* <HeroSection /> old */}
                      {/* <WorksMini /> */}
                      {/* <Providing /> old*/}
                      {/* <Work /> old services section */}
                      {/* <WorksGrid /> old */}
                      {/* <Works />  */}
                      {/* <Testimon />
                      <FaqSection />
                      <ContactForm /> old*/}
                    </>
                  }
                />
                {/* Lazy loaded routes */}
                <Route path="/services" element={<Services />} />
                <Route path="/services/:slug" element={<ServiceDetails />} />
                <Route path="/work" element={<WorkPage />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/about" element={<About />} />
                <Route
                  path="/contact"
                  element={
                    <div className="pt-0 md:pt-20">
                      <Contact1 />{" "}
                    </div>
                  }
                />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route
                  path="/digital-marketing-services"
                  element={<DigitalMarketing />}
                />
                <Route path="/thank-you" element={<Thanks />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              {/* ===================== ADMIN ROUTES ===================== */}
              <Route element={<AdminLayout />}>
                <Route
                  path="/admin-login"
                  element={
                    <PrivateRoute>
                      <AdminDashboard />
                    </PrivateRoute>
                  }
                />
              </Route>
            </Routes>
            <WhatsAppButton />
          </Suspense>
        </div>
        {/* </SmoothScrollProvider> */}
      </ModalProvider>
    </>
  );
}

export default App;
